module.exports = __webpack_public_path__ + "img/boho_rio_gift_samba.989aac90.svg";